const slowAsst =  window.slowAsst || null;
const noInternetAsst = window.noInternetAsst || null;

const AssetModel  = function(){
	//Delete window references
	delete window.slowAsst;
	delete window.noInternetAsst;

	return{
		getSlowImg:function(){
			return slowAsst;
		},
		getNoInternetImg:function(){
			return noInternetAsst;
		}
	}
};

export default AssetModel;


// WEBPACK FOOTER //
// ./src/model/AssetModel.js